import { get, post, put } from '@aiptyg/api-client';
import type {
  InvitationCodeListResponseDTO,
  CreateInvitationCodesRequest,
  CreateInvitationCodesResponse,
  AssignInvitationCodeRequest,
  AssignInvitationCodeResponse,
} from '../types/invitation.types';

export function listInvitationCodes(params: {
  page: number;
  pageSize: number;
  status: string;
}): Promise<InvitationCodeListResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page));
  qs.set('page_size', String(params.pageSize));
  if (params.status) qs.set('status', params.status);
  return get<InvitationCodeListResponseDTO>(`/v1/admin/invitation/codes?${qs.toString()}`);
}

export function createInvitationCodes(
  data: CreateInvitationCodesRequest,
): Promise<CreateInvitationCodesResponse> {
  const body: Record<string, unknown> = { ...data };
  return post<CreateInvitationCodesResponse>('/v1/admin/invitation/codes', body);
}

export function assignInvitationCode(
  data: AssignInvitationCodeRequest,
): Promise<AssignInvitationCodeResponse> {
  const body: Record<string, unknown> = { ...data };
  return put<AssignInvitationCodeResponse>('/v1/admin/invitation/user-code', body);
}
